module.exports = __webpack_public_path__ + "static/fonts/iconfont.7ebfd9ef.woff2";